import { render, staticRenderFns } from "./RainForest.vue?vue&type=template&id=215670f4&"
import script from "./RainForest.vue?vue&type=script&lang=js&"
export * from "./RainForest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports